import firebase from "@/firebase/firebase.js"
import "firebase/auth";

var firebaseui = require("firebaseui-ja");
require("firebaseui-ja/dist/firebaseui.css");

// FirebaseUI config.
const uiConfig = {
  signInSuccessUrl: '/',
  signInOptions: [
    //firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    //firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    //firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    firebase.auth.GithubAuthProvider.PROVIDER_ID,
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      requireDisplayName: true
    },
  ],
  tosUrl: '/tos',
  privacyPolicyUrl: '/privacy',
};

const ui = new firebaseui.auth.AuthUI(firebase.auth());
//ui.start('#firebaseui-auth-container', uiConfig);

export function uiStart(target) {
  ui.start(target, uiConfig);
}

export function isAuthenticated() {
  return firebase.auth().currentUser !== null;
}
